import { Paper, Stack, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { ProfileTreatmentsContent } from 'src/sections/@dashboard/profile/components/ProfileTreatments/ProfileTreatmentsContent';

export default function ProfileTabsTreatmentsPage() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Zabiegi | Vetsi</title>
      </Helmet>

      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: theme.customShadows.z8,
          height: 1,
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px' }}>
          <ProfileTreatmentsContent />
        </Stack>
      </Paper>
    </>
  );
}
